module.exports = __webpack_public_path__ + "img/img-empty-state-usage-policy.c190943d.svg";